import type { SVGProps } from 'react';
const SvgFilters = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M8.625 5a2 2 0 1 1 4 0m-4 0a2 2 0 1 0 4 0m-4 0h-6.75m10.75 0h1.5m-9.5 6a2 2 0 0 1 4 0m-4 0a2 2 0 0 0 4 0m-4 0h-2.75m6.75 0h5.5"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgFilters;
